import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { validateDateFilter, getCountries } from './helper';
import moment from 'moment';
import MultiSelect from '../MultiSelect/index';
import Select from 'react-select';
import { deleteEntityFilter } from '../../../Analyst/Cases/List/Helper';
import { HTTP_HEADERS } from '../../../constants';
import { CORE_API } from '../../../config';

const productTypes = [{ value: "NORMAL", label: "NORMAL" }, { value: "QUICK", label: "QUICK" }]
const caseTypes = [{ value: "DOMESTIC", label: "INDIAN" }, { value: "INTERNATIONAL", label: "INTERNATIONAL" }]
const statusTypes = [{ value: "PENDING", label: "PENDING" }, { value: "COMPLETED", label: "COMPLETED" }, { value: "UNALLOCATED", label: "UNALLOCATED" }, { value: "FAILURE", label: "FAILURE" }]

class FilterFormTypeOne extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toDate: null,
            fromDate: null,
            dateValidateFlag: true,
            selectedEntityData: [],
            errorMsg: '',
            selectedOption: '',
            selectedOptionCase: '',
            selectedOptionStatus: '',
            selectedOptionCountry: '',
            selectedProducts: [],
            availableProducts: [],
            productsLoading: false,
            productsError: ''
        }
    }
    handleFromDateChange = (date) => {
        this.setState({
            fromDate: date
        })
        if (date && this.state.toDate) {
            this.setState({
                dateValidateFlag: false
            })
        }
    }
    handleToDateChange = (date) => {
        this.setState({
            toDate: date
        });
        if (date && this.state.fromDate) {
            this.setState({
                dateValidateFlag: false
            })
        }
    }

    handleChangeProduct = (selectedProducts) => {
        this.setState({ selectedProducts: selectedProducts || [] });
    };

    componentDidMount() {
        if (this.props.availableProducts) {
            this.setState({ availableProducts: this.props.availableProducts });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.availableProducts !== prevProps.availableProducts) {
            this.setState({ 
                availableProducts: this.props.availableProducts || [],
                productsLoading: this.props.productsLoading || false,
                productsError: this.props.productsError || ''
            });
        }
        
        if (this.props.productsLoading !== prevProps.productsLoading) {
            this.setState({ 
                productsLoading: this.props.productsLoading || false
            });
        }
        
        if (this.props.productsError !== prevProps.productsError) {
            this.setState({ 
                productsError: this.props.productsError || ''
            });
        }
    }

    fetchProductsByCorporates = () => {
        const { selectedEntityData } = this.state;
        
        if (!selectedEntityData || selectedEntityData.length === 0) {
            this.setState({
                availableProducts: [],
                selectedProducts: [],
                productsLoading: false,
                productsError: ''
            });
            return;
        }

        const corporateIds = selectedEntityData.map(item => 
            typeof item === 'string' ? item : item.value || item.value
        );
        
        if (this.props.fetchProductsByCorporates) {
            this.props.fetchProductsByCorporates(corporateIds);
        } else {
            console.error('fetchProductsByCorporates function not available in props');
        }
    };

    handleApplyFilter = () => {
        const validate = validateDateFilter(this.state.toDate, this.state.fromDate);
        if (validate.validationFlag) {
            this.setState(prevState => ({
                errorMsg: ''
            }))
            let date = {
                toDate: this.state.toDate,
                fromDate: this.state.fromDate
            }
            if(this.props.statusTypeFlag || this.props.countryFlag){
                this.props.filterCallback(this.state.selectedOption, this.state.selectedOptionStatus, this.state.selectedOptionCountry,
                    this.state.selectedEntityData, date, this.state.selectedProducts, true, false);
            } else {
                this.props.filterCallback(this.state.selectedOption, this.state.selectedOptionCase,
                    this.state.selectedEntityData, date, this.state.selectedProducts, true, false);
            }
        } else {
            if (validate.validationMessage) {
                this.setState({
                    errorMsg: validate.validationMessage,
                })
            } else {
                this.setState({
                    toDate: null,
                    fromDate: null
                })
                let date = {
                    toDate: null,
                    fromDate: null
                }
                if(this.props.statusTypeFlag || this.props.countryFlag){
                    this.props.filterCallback(this.state.selectedOption, this.state.selectedOptionStatus, this.state.selectedOptionCountry,
                        this.state.selectedEntityData, date, this.state.selectedProducts, true, false);
                } else {
                    this.props.filterCallback(this.state.selectedOption, this.state.selectedOptionCase,
                        this.state.selectedEntityData, date, this.state.selectedProducts , true, false);
                }
            }

        }
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption: selectedOption })
    }

    handleChangeCase = (selectedOptionCase) => {
        this.setState({ selectedOptionCase: selectedOptionCase })
    }

    handleChangeStatus = (selectedOptionStatus) => {
        this.setState({ selectedOptionStatus: selectedOptionStatus })
    }

    handleChangeCountry = (selectedOptionCountry) => {
        this.setState({ selectedOptionCountry: selectedOptionCountry })
    }

    handleResetDateFilter = () => {
        this.setState({
            toDate: null,
            fromDate: null,
            dateValidateFlag: true,
            selectedEntityData: [],
            selectedOption: '',
            selectedOptionCase: '',
            selectedOptionStatus: '',
            selectedOptionCountry: '',
            selectedProducts: [],
            availableProducts: []
        });
        let date = {
            toDate: null,
            fromDate: null
        }
        if (this.props.countryFlag) {
            this.props.filterCallback(null, null, null, [], date, [], true, true)
        } else {
            this.props.filterCallback(null, null, [], date, [], true, true)
        }
    }
    handleRemoveFilter = (removeFilter) => {
        if (removeFilter.value === 'country') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: ''
                })
        }else if (removeFilter.value === 'statusType') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: '',
                selectedOptionCountry: this.state.selectedOptionCountry
                })
        } else if (removeFilter.value === 'caseType') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: '',
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: this.state.selectedOptionCountry
                })
        } else if (removeFilter.value === 'productType') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: '',
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: this.state.selectedOptionCountry
            })
        } else if (removeFilter.value === 'product') {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: this.state.selectedOptionCountry,
                selectedProducts: []
            })
        } else if (removeFilter.value === 'date') {
            this.setState({
                toDate: null,
                fromDate: null,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: this.state.selectedEntityData,
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,
                selectedOptionCountry: this.state.selectedOptionCountry
            })
        } else {
            this.setState({
                toDate: this.state.toDate,
                fromDate: this.state.fromDate,
                dateValidateFlag: this.state.dateValidateFlag,
                selectedEntityData: deleteEntityFilter(this.state.selectedEntityData, removeFilter),
                selectedOption: this.state.selectedOption,
                selectedOptionCase: this.state.selectedOptionCase,
                selectedOptionStatus: this.state.selectedOptionStatus,    
                selectedOptionCountry: this.state.selectedOptionCountry            
            })
        }
    }

    handleFilterOnPageRefreshOrBackButton = (urlFilters) => {
        this.setState({
            toDate: urlFilters.toDate ? urlFilters.toDate : null,
            fromDate: urlFilters.fromDate ? urlFilters.fromDate : null,
            dateValidateFlag: true,
            selectedEntityData: urlFilters.selectedCorporates.length !== 0 ? urlFilters.selectedCorporates : [],
            selectedOption: urlFilters.productType ? urlFilters.productType : '',
            selectedOptionCase: urlFilters.caseType ? urlFilters.caseType : '',
            selectedOptionStatus: urlFilters.statusType ? urlFilters.statusType : '',
            selectedOptionCountry: urlFilters.country ? urlFilters.country : '',
            selectedProducts: urlFilters.selectedProducts ? urlFilters.selectedProducts : []
        }, () => {
            if (this.state.selectedEntityData.length > 0) {
                this.fetchProductsByCorporates();
            }
        })
    }

    hideFilter = () => {
        this.props.hideFilterCallback()
    }
    selectedEntityCallback = (selectedData) => {
        this.setState({
            selectedEntityData: selectedData
        }, () => {
            this.fetchProductsByCorporates();
        })
    }
    render() {
        return (
            <div>
                <Row className="mb-3 align-items-center">                                                           
                    <Col xs="4" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">{this.props.multiselectTitle}</span>
                    </Col>
                    <Col sm="9" className="filter-category py-sm-20">
                        <MultiSelect data={this.props.correspondentList} selected={this.selectedEntityCallback} selectedValue={this.state.selectedEntityData} />
                    </Col>
                    <Col xs='4'>
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">{this.props.dateFilterType}</span>
                    </Col>
                    <Col sm="7">
                        <div className="d-flex align-items-center">
                            <DatePicker className="form-control" selected={(this.state.fromDate!==null) ? new Date(this.state.fromDate) : null} onChange={this.handleFromDateChange} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-YYYY" maxDate={new Date()} />
                            <span><i className="icon-minus text-dark"></i></span>
                            <DatePicker className="form-control" selected={(this.state.toDate!==null) ? new Date(this.state.toDate) : null} onChange={this.handleToDateChange} placeholderText="DD-MM-YYYY" dateFormat="dd-MM-YYYY" maxDate={new Date()} />
                        </div>
                        <div>
                            <span className="text-danger">{this.state.errorMsg}</span>
                        </div>
                    </Col>
                </Row>
                    {/* <Col sm="11" className="filter-category py-sm-20">
                            <BillingFilter dateFilter={this.dateFilterCallBack} />
                        </Col> */}
                <Row className="mb-3 align-items-center">
                    {this.props.productTypeFlag && <Col xs="3" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Product Type</span>
                    </Col>
                    }
                    {this.props.productTypeFlag && <Col xs="9" sm={5}>
                        <Select
                            value={this.state.selectedOption}
                            onChange={this.handleChange}
                            options={productTypes}
                            isClearable={true} />
                    </Col>
                    }

                    {this.props.caseTypeFlag && <Col xs="3" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Case Type</span>
                    </Col>
                    }
                    {this.props.caseTypeFlag && <Col xs="9" sm={5}>
                        <Select
                            value={this.state.selectedOptionCase}
                            onChange={this.handleChangeCase}
                            options={caseTypes}
                            isClearable={true} />
                    </Col>
                    }

                   
                    {this.state.selectedEntityData.length > 0 && <Col xs="3" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">
                            Product
                        </span>
                    </Col>
                    }

                    {this.state.selectedEntityData.length > 0 && <Col xs="9" sm={5}>
                        <Select
                            value={this.state.selectedProducts}
                            onChange={this.handleChangeProduct}
                            options={this.state.availableProducts}
                            isMulti={true}
                            isDisabled={this.state.selectedEntityData.length === 0 || this.state.productsLoading}
                            isLoading={this.state.productsLoading}
                            isClearable={true}
                            closeMenuOnSelect={false}
                        />
                        {this.state.productsError && <span className="text-danger text-sm">{this.state.productsError}</span>}
                    </Col>
                    }

                    {this.props.statusTypeFlag && <Col xs="3" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Status</span>
                    </Col>

                    }
                    {this.props.statusTypeFlag && <Col xs="9" sm={5}>
                        <Select
                            value={this.state.selectedOptionStatus}
                            onChange={this.handleChangeStatus}
                            options={statusTypes}
                            isClearable={true} />
                    </Col>
                    }
                    
                    {this.props.countryFlag && <Col xs="3" className="filter-category py-0 py-sm-20">
                        <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">Country</span>
                    </Col>

                    }
                    {this.props.countryFlag && <Col xs="9" sm={5}>
                        <Select
                            value={this.state.selectedOptionCountry}
                            onChange={this.handleChangeCountry}
                            options={getCountries()}
                            isClearable={true} />
                    </Col>
                    }
                </Row>
                <div className="d-flex justify-content-between">
                    <div>
                        <Button className="mr-3" outline color="primary" onClick={this.hideFilter}>Hide Filters</Button>
                        <Button outline color="primary" onClick={this.handleResetDateFilter}>Reset Filters</Button>
                    </div>
                    <div>
                        <Button color="primary" onClick={this.handleApplyFilter}>Apply</Button>
                    </div>
                </div>
            </div> 
        )
    }
}
export default FilterFormTypeOne;